<template>
    <v-col
      cols="12"
      md="12"
    >
    <slot></slot>
  </v-col>
</template>

<script>
export default {
  name: "Col12"
}
</script>

<style scoped>

</style>